(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ih-cart-sales"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async event => {
  const button = event.target.closest('[data-ih-feedback-save],[data-ih-feedback-skip]');
  const root = button?.closest('[data-ih-cart-feedback]');
  if (!root) return;
  if (button.hasAttribute('data-ih-feedback-skip')) {
    root.open = false; root.querySelector('summary').focus(); return;
  }
  if (root.dataset.busy === 'true') return;
  const reason = root.querySelector('[data-ih-feedback-reason]');
  const comment = root.querySelector('[data-ih-feedback-comment]');
  const status = root.querySelector('[data-ih-feedback-status]');
  const attributes = { 'Purchase hesitation reason': reason.value, 'Purchase hesitation comment': comment.value.trim().slice(0,400) };
  root.dataset.busy = 'true'; button.disabled = true; root.setAttribute('aria-busy','true'); status.textContent = '';
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(),10000);
  try {
    const response = await fetch(root.dataset.updateUrl, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes}),signal:controller.signal});
    if (!response.ok) throw new Error();
    const cart = await response.json();
    if (Object.entries(attributes).some(([key,value]) => (cart.attributes?.[key] || '') !== value)) throw new Error();
    status.textContent = Object.values(attributes).some(Boolean) ? root.dataset.saved : root.dataset.cleared;
  } catch (_) { status.textContent = root.dataset.error; }
  finally { clearTimeout(timer); delete root.dataset.busy; button.disabled = false; root.removeAttribute('aria-busy'); }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ih-sales-contact"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const root = document.getElementById('ih-sales-ui');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const main = document.querySelector('#MainContent');
    const panel = root.querySelector('[data-ih-sales-contact]');
    const dialog = root.querySelector('#ih-store-dialog');
    const dock = root.querySelector('.ih-sales-dock');
    const quoteLabel = root.querySelector('[data-ih-quote-label]').textContent;
    let returnFocus;
    if (panel && main) {
      if (root.dataset.pageType === 'product') {
        const lead = root.dataset.leadFirst === 'true';
        const clarity = main.querySelector('[data-ih-order-clarity]');
        const price = main.querySelector('.productView-price');
        const buy = main.querySelector('product-form,form[data-type="add-to-cart-form"]');
        const anchor = lead ? (clarity || price) : (buy || price);
        if (anchor) anchor.after(panel); else main.append(panel);
        document.dispatchEvent(new Event('ih:sales-contact-ready'));
        const visible = element => element && element.getBoundingClientRect().width > 0 && element.getBoundingClientRect().height > 0 && getComputedStyle(element).visibility !== 'hidden';
        const refreshChatClearance = () => {
          const chat = document.querySelector('shopify-chat');
          const chatRoot = chat?.shadowRoot;
          const activator = chatRoot?.querySelector('[part~="activator"]') || chatRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part~="activator"]');
          let overlap = false;
          if (matchMedia('(max-width:749px)').matches && activator && activator.getAttribute('aria-expanded') !== 'true' && document.activeElement !== chat) {
            const bubble = activator.getBoundingClientRect();
            if (bubble.width && bubble.height) {
              overlap = Array.from(main.querySelectorAll('.productView-title,.productView-price,.productView-subtotal,.ih-sales-contact,.productView-options,.ih-fitment-panel,.ih-cover-fitment,[data-ih-tray-choices],.ih-lock-options,[data-ih-order-clarity]')).some(element => {
                if (!visible(element)) return false;
                const bounds = element.getBoundingClientRect();
                return bounds.left < bubble.right + 8 && bounds.right > bubble.left - 8 && bounds.top < bubble.bottom + 8 && bounds.bottom > bubble.top - 8;
              });
            }
          }
          document.body.classList.toggle('ih-product-chat-clearance',overlap);
        };
        let chatRefreshQueued = false;
        const scheduleChatClearance = () => {
          if (chatRefreshQueued) return;
          chatRefreshQueued = true;
          requestAnimationFrame(() => {chatRefreshQueued = false; refreshChatClearance();});
        };
        window.addEventListener('scroll',scheduleChatClearance,{passive:true});
        window.addEventListener('resize',scheduleChatClearance);
        window.addEventListener('pageshow',scheduleChatClearance);
        main.addEventListener('focusin',scheduleChatClearance);
        main.addEventListener('focusout',scheduleChatClearance);
        customElements.whenDefined('shopify-agent-runtime').then(scheduleChatClearance);
        const gallery = main.querySelector('.productView-images');
        if (gallery) {
          const zoomLabel = root.querySelector('[data-ih-image-zoom-label]').textContent.trim();
          const syncImageControls = () => {
            gallery.querySelectorAll('.productView-image .media[data-fancybox="images"]').forEach(control => {
              const image = control.querySelector('img');
              if (!image) return;
              const slide = control.closest('.slick-slide');
              const tabIndex = slide?.getAttribute('aria-hidden') === 'true' ? '-1' : '0';
              const label = zoomLabel + (image.alt ? ': ' + image.alt : '');
              control.dataset.ihImageZoom = 'true';
              control.setAttribute('role','button');
              control.setAttribute('aria-haspopup','dialog');
              if (control.getAttribute('tabindex') !== tabIndex) control.setAttribute('tabindex',tabIndex);
              if (control.getAttribute('aria-label') !== label) control.setAttribute('aria-label',label);
            });
          };
          syncImageControls();
          new MutationObserver(syncImageControls).observe(gallery,{childList:true,subtree:true,attributes:true,attributeFilter:['class','aria-hidden']});
          gallery.addEventListener('keydown', event => {
            const control = event.target.closest('[data-ih-image-zoom]');
            if (!control || !['Enter',' '].includes(event.key)) return;
            event.preventDefault();
            if (!event.repeat) control.click();
          });
        }
        let order, purchaseButton;
        const dockBuy = root.querySelector('[data-ih-dock-buy]');
        const dockPrice = root.querySelector('[data-ih-dock-price]');
        const variantData = JSON.parse(root.querySelector('[data-ih-dock-variants]').textContent);
        const variants = variantData.ids.map((id,index) => ({id,price:variantData.prices[index]}));
        const chooseCopy = root.querySelector('[data-ih-dock-choose]').textContent;
        const addCopy = root.querySelector('[data-ih-dock-add]').textContent;
        const addingCopy = root.querySelector('[data-ih-dock-adding]').textContent;
        const money = value => new Intl.NumberFormat('en-CA',{style:'currency',currency:root.dataset.currency}).format(value / 100) + ' ' + root.dataset.currency;
        const missingField = () => {
          if (!purchaseButton?.form) return null;
          const invalid = Array.from(purchaseButton.form.elements).find(field => !field.disabled && field.willValidate && !field.checkValidity());
          if (invalid) return invalid;
          return Array.from(main.querySelectorAll('#ih-vehicle-year,#ih-vehicle-model,.ih-fitment-bed select')).find(field => !field.disabled && !field.value) || null;
        };
        const refreshPurchase = () => {
          refreshChatClearance();
          purchaseButton = Array.from(main.querySelectorAll('[data-btn-addToCart],button[name="add"]')).find(visible);
          order = Array.from(main.querySelectorAll('.ih-fitment-panel,.ih-cover-fitment,[data-ih-tray-choices],.productView-options,product-form,form[data-type="add-to-cart-form"]')).find(visible);
          const busy = Boolean(purchaseButton && (purchaseButton.classList.contains('is-loading') || purchaseButton.getAttribute('aria-disabled') === 'true'));
          const available = Boolean(purchaseButton && order && (!purchaseButton.disabled || busy));
          root.querySelectorAll('[data-ih-online-order-link],[data-ih-accessory-quote]').forEach(link => {if (link.hidden === available) link.hidden = !available;});
          root.querySelectorAll('[data-ih-purchase-fallback]').forEach(link => {if (link.hidden !== available) link.hidden = available;});
          if (order) order.id = order.id || 'ih-online-order';
          if (!available) return;
          dockBuy.disabled = busy;
          const label = busy ? addingCopy : missingField() ? chooseCopy : addCopy;
          if (dockBuy.textContent !== label) dockBuy.textContent = label;
          const variantId = purchaseButton.form?.querySelector('[name="id"]')?.value;
          const variant = variants.find(item => String(item.id) === variantId);
          const quantityInput = main.querySelector('#ih-lock-pairs') || purchaseButton.form?.querySelector('[name="quantity"]');
          const quantity = Math.max(1,Number(quantityInput?.value) || 1);
          const addons = main.querySelector('[data-ih-addon-total]');
          const addonPrice = addons ? Math.round(Number(addons.textContent.replace(/[^0-9.]/g,'')) * 100) : 0;
          if (variant && Number.isFinite(addonPrice)) {
            const total = money((variant.price + addonPrice) * quantity);
            if (dockPrice.textContent !== total) dockPrice.textContent = total;
          }
        };
        let queued = false;
        const scheduleRefresh = () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => {queued = false; refreshPurchase();});
        };
        refreshPurchase();
        let refreshCount = 0;
        const refreshTimer = setInterval(() => {refreshPurchase(); if (++refreshCount >= 20) clearInterval(refreshTimer);}, 250);
        main.addEventListener('change', () => {scheduleRefresh(); setTimeout(scheduleRefresh,150); setTimeout(scheduleRefresh,500);});
        main.addEventListener('input', event => {
          const quantity = event.target;
          if (quantity.matches('input[name="quantity"].quantity__input') && quantity.value && Number.isSafeInteger(Number(quantity.value)) && quantity.checkValidity()) {
            quantity.dispatchEvent(new Event('change', {bubbles:true}));
          }
          scheduleRefresh();
        });
        window.addEventListener('pageshow', () => {
          const quantity = purchaseButton?.form?.querySelector('input[name="quantity"].quantity__input');
          if (quantity && quantity.value !== quantity.defaultValue) quantity.dispatchEvent(new Event('change', {bubbles:true}));
          scheduleRefresh();
        });
        new MutationObserver(scheduleRefresh).observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','value'],characterData:true});
        dockBuy.addEventListener('click', () => {
          refreshPurchase();
          if (!purchaseButton || purchaseButton.disabled || dockBuy.disabled) return;
          const missing = missingField();
          if (missing) {
            const details = missing.closest('details');
            if (details) details.open = true;
            missing.focus({preventScroll:true});
            missing.scrollIntoView({behavior:'smooth',block:'center'});
            return;
          }
          dockBuy.disabled = true;
          dockBuy.textContent = addingCopy;
          purchaseButton.click();
          setTimeout(scheduleRefresh,150);
        });
        if (panel.parentElement && root.dataset.leadFirst === 'false') panel.classList.add('ih-sales-contact--accessory');
      } else if (root.dataset.pageType === 'index') {
        const hero = main.querySelector('[id$="__16321237356a896dad"]');
        panel.classList.add('ih-sales-contact--wide');
        const finder = main.querySelector('[data-ih-truck-finder]');
        if (finder) finder.closest('.shopify-section').after(panel);
        else if (hero) hero.after(panel); else main.prepend(panel);
      } else {
        if (root.dataset.pageType === 'collection') panel.classList.add('ih-sales-contact--wide','ih-sales-contact--collection');
        const finder = main.querySelector('[data-ih-truck-finder]');
        const collectionHeader = root.dataset.pageType === 'collection' ? main.querySelector('h1')?.closest('.shopify-section') : null;
        if (finder) finder.closest('.shopify-section').after(panel);
        else if (collectionHeader && collectionHeader.parentElement === main) collectionHeader.after(panel);
        else main.prepend(panel);
      }
    }
    if (panel && main && root.dataset.pageType === 'collection') {
      const intro = main.querySelector('.ih-category-intro');
      const details = panel.querySelector('[data-ih-category-details]');
      if (intro && details) {
        const originalParent = intro.parentElement;
        const originalNext = intro.nextSibling;
        const mobile = matchMedia('(max-width:749px)');
        const mergeCategoryHelp = () => {
          if (mobile.matches) {
            details.append(intro);
            details.hidden = false;
            originalParent.classList.add('ih-category-intro-slot--collapsed');
          } else {
            originalParent.insertBefore(intro,originalNext);
            originalParent.classList.remove('ih-category-intro-slot--collapsed');
            details.open = false;
            details.hidden = true;
          }
        };
        mergeCategoryHelp();
        mobile.addEventListener('change',mergeCategoryHelp);
      }
    }
    if (dock) document.body.classList.add('ih-has-sales-dock');
    if (dock && panel && main && ['product', 'collection'].includes(root.dataset.pageType)) {
      const mobile = matchMedia('(max-width:749px)');
      const visible = element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
      const refreshDock = () => {
        const actions = Array.from(panel.querySelectorAll('.ih-sales-contact__actions a,.ih-sales-contact__actions button')).filter(visible);
        const purchase = root.dataset.pageType === 'product'
          ? Array.from(main.querySelectorAll('[data-btn-addToCart],button[name="add"]')).find(visible)
          : null;
        if (purchase) actions.push(purchase);
        const primaryVisible = mobile.matches && actions.length > 0 && !dock.contains(document.activeElement) && actions.every(element => {
          const bounds = element.getBoundingClientRect();
          return bounds.top >= 80 && bounds.bottom <= window.innerHeight - 16;
        });
        dock.classList.toggle('ih-primary-actions-visible', primaryVisible);
      };
      let refreshQueued = false;
      const scheduleDock = () => {
        if (refreshQueued) return;
        refreshQueued = true;
        requestAnimationFrame(() => {refreshQueued = false; refreshDock();});
      };
      window.addEventListener('scroll', scheduleDock, {passive: true});
      window.addEventListener('resize', scheduleDock);
      window.addEventListener('pageshow', scheduleDock);
      window.addEventListener('load', scheduleDock);
      root.addEventListener('focusin', scheduleDock);
      root.addEventListener('focusout', scheduleDock);
      new ResizeObserver(scheduleDock).observe(main);
      scheduleDock();
    }
    document.querySelectorAll('a[href*="/pages/getaquote"]').forEach(link => {
      if (/^(Get a Store-Specific Quote|Get A Quote|Check Fitment & Get a Quote)$/i.test(link.textContent.trim())) link.textContent = quoteLabel;
    });
    const headerQuote = document.querySelector('header a[href*="/pages/getaquote"],.wrapper-header a[href*="/pages/getaquote"]');
    if (headerQuote && !headerQuote.parentElement.querySelector('[data-ih-call-store]')) headerQuote.after(root.querySelector('[data-ih-header-call]').content.cloneNode(true));
    const footerQuote = document.querySelector('.ironhaul-local-links a[href*="/pages/getaquote"],footer a[href*="/pages/getaquote"]');
    if (footerQuote && !footerQuote.parentElement.querySelector('[data-ih-call-store]')) footerQuote.after(root.querySelector('[data-ih-header-call]').content.cloneNode(true));
    const selectedAddonNotes = () => {
      const items = Array.from(document.querySelectorAll('.ih-addon-list .ih-addon-item')).flatMap(item => {
        const name = item.querySelector('strong')?.textContent.trim();
        if (!name) return [];
        const select = item.querySelector('select');
        if (select && !select.disabled && Number(select.value) > 0) {
          return [name + ': ' + select.options[select.selectedIndex].textContent.trim()];
        }
        if (item.matches('button[aria-pressed="true"]:not(:disabled)')) return [name + ': 1'];
        return [];
      });
      if (!items.length) return '';
      return root.querySelector('[data-ih-addon-quote-label]').textContent.trim() + '\n' + items.join('\n');
    };
    const selectedOptionNotes = () => {
      const picker = document.querySelector('main [id^="product-option-"]');
      const options = new Map();
      picker?.querySelectorAll('select[name^="options["],input[type="radio"]:checked').forEach(field => {
        if (field.disabled || !field.value || field.value === 'Default Title') return;
        const name = field.name.replace(/^options\[/, '').replace(/\]$/, '');
        if (name) options.set(name, field.value);
      });
      main?.querySelectorAll('.ih-lock-options select').forEach(field => {
        if (field.disabled || !field.value) return;
        const name = field.labels?.[0]?.textContent.trim();
        const value = field.options[field.selectedIndex]?.textContent.split(' — ')[0].trim();
        if (name && value) options.set(name, value);
      });
      if (!main?.querySelector('.ih-lock-options')) {
        const quantity = Array.from(main?.querySelectorAll('[name="quantity"]') || []).find(field => {
          const bounds = field.getBoundingClientRect();
          return !field.disabled && bounds.width > 0 && bounds.height > 0 && getComputedStyle(field).visibility !== 'hidden';
        });
        const count = Number(quantity?.value);
        if (Number.isSafeInteger(count) && count > 0 && quantity.checkValidity()) {
          options.set(root.querySelector('[data-ih-quantity-quote-label]').textContent.trim(), String(count));
        }
      }
      if (!options.size) return '';
      return root.querySelector('[data-ih-option-quote-label]').textContent.trim() + '\n' + Array.from(options, ([name, value]) => name + ': ' + value).join('\n');
    };
    const homeQuoteBases = new Map();
    const contextLink = link => {
      const destination = new URL(link.href);
      if (destination.origin !== location.origin) return;
      const contact = destination.pathname === '/pages/contact';
      if (destination.pathname !== '/pages/getaquote' && !(contact && root.dataset.pageType === 'product')) return;
      if (root.dataset.pageType === 'index') {
        if (!homeQuoteBases.has(link)) homeQuoteBases.set(link, link.href);
        link.href = homeQuoteBases.get(link);
      }
      const original = new URL(link.href);
      if (root.dataset.pageType === 'page' && ['/pages/getaquote', '/pages/contact'].includes(location.pathname)) {
        const current = new URL(location.href);
        if (current.searchParams.get('source') === 'cart-sales') original.searchParams.set('source', 'cart-sales');
        ['product', 'product_url', 'vehicle', 'addons'].forEach(key => {
          const value = current.searchParams.get(key);
          if (value || (key === 'addons' && current.searchParams.has(key))) original.searchParams.set(key, value);
        });
        link.href = original.href;
        return;
      }
      if (root.dataset.pageType === 'search') {
        const searchContext = new URL(root.dataset.quoteUrl, location.origin);
        const interest = searchContext.searchParams.get('product');
        if (!interest) return;
        const linkedProduct = new URL(original.searchParams.get('product_url') || '', location.origin);
        if (linkedProduct.origin === location.origin && linkedProduct.pathname.startsWith('/products/')) return;
        const searchPage = new URL(location.href);
        searchPage.searchParams.delete('preview_theme_id');
        original.searchParams.set('product', interest);
        original.searchParams.set('product_url', searchPage.href);
        if (!original.searchParams.has('source')) original.searchParams.set('source', searchContext.searchParams.get('source'));
        link.href = original.href;
        return;
      }
      if (root.dataset.pageType === 'collection' || root.dataset.pageType === 'index') {
        const finder = main?.querySelector('[data-ih-truck-finder]');
        const category = finder?.querySelector('[data-ih-truck-category]');
        const model = finder?.querySelector('[data-ih-truck-model]');
        const browse = finder?.querySelector('[data-ih-truck-all]');
        const home = root.dataset.pageType === 'index';
        if (home && (!finder || (!model?.value && !new URL(location.href).searchParams.has('truck_category')) || original.searchParams.get('source') === 'home-callback')) return;
        const categoryChanged = category && (home || category.value !== root.dataset.collectionHandle);
        const title = categoryChanged ? category.options[category.selectedIndex].textContent.trim() : root.dataset.collectionTitle;
        const path = home ? '/collections/' + category.value : categoryChanged ? browse?.getAttribute('href') : root.dataset.collectionUrl;
        let productInquiry = false;
        try {
          const linkedProduct = new URL(original.searchParams.get('product_url') || '', location.origin);
          productInquiry = linkedProduct.origin === location.origin && linkedProduct.pathname.startsWith('/products/');
        } catch (_) {}
        if (title && path && !productInquiry) {
          original.searchParams.set('product', title);
          original.searchParams.set('product_url', new URL(path, location.origin).href);
        }
        if (model?.value) original.searchParams.set('vehicle', model.options[model.selectedIndex].textContent.trim());
        else original.searchParams.delete('vehicle');
        link.href = original.href;
        return;
      }
      if (root.dataset.pageType === 'cart') {
        original.searchParams.set('source', 'cart-sales');
        const cartNote = document.getElementById('cart-note');
        if (cartNote) original.searchParams.set('addons', cartNote.value);
        link.href = original.href;
        return;
      }
      if (root.dataset.pageType !== 'product') return;
      const withContext = new URL(root.dataset.quoteUrl, location.origin);
      withContext.searchParams.forEach((value,key) => original.searchParams.set(key,value));
      const productUrl = new URL(withContext.searchParams.get('product_url'));
      const variantData = JSON.parse(root.querySelector('[data-ih-dock-variants]').textContent);
      const picker = main?.querySelector('[id^="product-option-"]');
      const selections = Array.from(picker?.querySelectorAll('select[name^="options["],input[type="radio"]:checked') || [], field => field.value);
      const index = selections.length ? variantData.options.findIndex(values => values.length === selections.length && values.every((value, i) => value === selections[i])) : variantData.ids.findIndex(id => String(id) === new URL(location.href).searchParams.get('variant'));
      productUrl.searchParams.delete('variant');
      if (index >= 0) productUrl.searchParams.set('variant', String(variantData.ids[index]));
      original.searchParams.set('product_url', productUrl.href);
      const existing = document.querySelector('.ih-fitment-panel a[href*="vehicle="],.ih-cover-fitment a[href*="vehicle="],.ih-sales-contact a[href*="vehicle="]');
      if (main?.querySelector('#ih-cover-year')) {
        const vehicle = ['year', 'make', 'model', 'cab', 'bed'].map(key => {
          const value = main.querySelector('#ih-cover-' + key)?.value.trim();
          return value ? value + (key === 'bed' ? ' in bed' : '') : '';
        }).filter(Boolean).join(' / ');
        if (vehicle) original.searchParams.set('vehicle', vehicle);
        else original.searchParams.delete('vehicle');
      } else if (existing && !original.searchParams.has('vehicle')) {
        const vehicle = new URL(existing.href).searchParams.get('vehicle');
        if (vehicle) original.searchParams.set('vehicle',vehicle);
      }
      const addons = [selectedOptionNotes(), selectedAddonNotes()].filter(Boolean).join('\n\n');
      if (addons) original.searchParams.set('addons', addons);
      else original.searchParams.delete('addons');
      link.href = original.href;
    };
    const refreshPageQuotes = () => {
      if (!['collection', 'index', 'cart', 'search'].includes(root.dataset.pageType) && !(root.dataset.pageType === 'page' && location.pathname === '/pages/contact')) return;
      document.querySelectorAll('a[href*="/pages/getaquote"]').forEach(contextLink);
    };
    const refreshProductLinks = () => {
      if (root.dataset.pageType !== 'product') return;
      document.querySelectorAll('a[href*="/pages/contact"],a[href*="/pages/getaquote"]').forEach(contextLink);
    };
    refreshPageQuotes();
    refreshProductLinks();
    window.addEventListener('pageshow', refreshProductLinks);
    window.addEventListener('load', refreshProductLinks);
    document.addEventListener('input', event => {
      if (event.target.closest('main')) queueMicrotask(refreshProductLinks);
    });
    document.addEventListener('change', event => {
      if (event.target.matches('[data-ih-truck-category],[data-ih-truck-model]')) refreshPageQuotes();
      if (event.target.closest('main')) queueMicrotask(refreshProductLinks);
    });
    document.addEventListener('click', event => {
      const opener = event.target.closest('[data-ih-call-store]');
      if (opener) {returnFocus = opener; dialog.showModal();}
      if (event.target.closest('[data-ih-close-store]')) dialog.close();
      const link = event.target.closest('a[href*="/pages/getaquote"],a[href*="/pages/contact"]');
      if (link) contextLink(link);
      if (event.target.closest('main')) queueMicrotask(refreshProductLinks);
    });
    dialog.addEventListener('close', () => {if (returnFocus) returnFocus.focus();});
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || !dialog.open) return;
      const controls = Array.from(dialog.querySelectorAll('button:not([disabled]),a[href],[tabindex]'))
        .filter(element => element.tabIndex >= 0 && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (!first) return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
  } catch(e) { console.error(e); }
})();

})();
